export default __webpack_public_path__ + "static/media/Resume.c95bfc72.pdf";